import { isUserAdminTier } from '@shared/services/checkUserTierService';
import { PAGE_MODE } from '../../../constants/pageModeTypes';
import PrivilegeNames from '../../../../../constants/privilegeNames';
import * as systemRoles from '../../../../../constants/system-roles';

const PAGE_MODES_CAN_ACCESS_PERMISSIONS = [PAGE_MODE.FDAVipOrg, PAGE_MODE.MddapOrg];
const PAGE_MODES_CAN_ACCESS_ATM_CHECKBOX = [
  PAGE_MODE.ISACAVipOrg,
  PAGE_MODE.FDAVipOrg,
  PAGE_MODE.MddapOrg,
  PAGE_MODE.OrgUnit
];

const ORG_ORG_UNIT_PAGE_MODES = [PAGE_MODE.MddapOrg, PAGE_MODE.OrgUnit];

const COORDINATOR_SYSTEM_ROLES = [systemRoles.ORG_COORDINATOR, systemRoles.ORG_UNIT_COORDINATOR];

export const getUserAssignEditPermissions = (
  currentUserTier,
  pageMode,
  privileges,
  isFree,
  selectedRole
) => {
  const isUserAbleToSetSuperUserCheckbox =
    isUserAdminTier(currentUserTier) &&
    pageMode !== PAGE_MODE.ISACAVipOrg &&
    pageMode !== PAGE_MODE.ISACAAppraiser &&
    !isFree;

  const isUserAbleToSetATMCheckbox =
    PAGE_MODES_CAN_ACCESS_ATM_CHECKBOX.includes(pageMode) &&
    !isFree &&
    privileges.includes(PrivilegeNames.UserManagement_LicenseChange_AppraiserAtm);

  const isUserAbleToDeactivateUser = privileges.includes(
    PrivilegeNames.UserManagement_ChangeLicense_DeactivatedLicenses
  );

  const isUserAbleToSetViewInvoicesCheckbox = canSetViewInvoicesCheckbox(
    selectedRole,
    isFree,
    pageMode,
    privileges
  );

  const shouldShowRoleAndPermissions = pageMode !== PAGE_MODE.ISACAAppraiser;

  const shouldShowPermissions = PAGE_MODES_CAN_ACCESS_PERMISSIONS.includes(pageMode) && !isFree;

  return {
    isUserAbleToSetSuperUserCheckbox,
    isUserAbleToSetATMCheckbox,
    isUserAbleToDeactivateUser,
    isUserAbleToSetViewInvoicesCheckbox,
    shouldShowRoleAndPermissions,
    shouldShowPermissions
  };
};

const canSetViewInvoicesCheckbox = (selectedRole, isFree, pageMode, privileges) => {
  const isCoordinator = selectedRole && COORDINATOR_SYSTEM_ROLES.includes(selectedRole);
  const isFreeOrgOrgUnit = isFree && ORG_ORG_UNIT_PAGE_MODES.includes(pageMode);
  const hasPrivilegeToSetAccessInvoices = privileges.includes(
    PrivilegeNames.UserManagement_SetAccessInvoices
  );

  return hasPrivilegeToSetAccessInvoices && (isCoordinator || isFreeOrgOrgUnit);
};
